const MutationUpdateSecuritySetting = `
  mutation (
    $enabling: Boolean,
    $provider: String,
    $appEnabling: Boolean,
    $tenantId: String,
    $clientId: String,
    $clientSecret: String,
    $redirectUri: String,
    $idleTime: Int,
    $whitelistIps: [String!]
  ) {
    tenantSecuritySettingUpdate(
      input: {
        enabling: $enabling,
        provider: $provider,
        appEnabling: $appEnabling,
        tenantId: $tenantId,
        clientId: $clientId,
        clientSecret: $clientSecret,
        redirectUri: $redirectUri,
        idleTime: $idleTime,
        whitelistIps: $whitelistIps
      }
    ) {
      setting {
        id
        values
      }
    }
  }
`

export default MutationUpdateSecuritySetting
